import { Deserializable } from '../deserializable';
import { Users } from './users';

export class UserProfile implements Deserializable {
  public id: number;
  public userId: number;
  public fullName: string = '';
  public displayName: string = '';
  public dob: string;
  public gender: string;
  public idNumber: string;
  public avatarId: number = 9;
  public tradingPaused: boolean;
  public tradingPausedReason: string;
  public physicalAddress: string;
  public sofDescription: string;

  //Sars Info
  public sarsUsername: string;
  public sarsPassword: string;

  public onboardingComplete: boolean;
  public onboardingReason: string;
  public fiaAmount: number;
  public adminFiaAmount: number;
  public sdaAmount: number;
  public adminSdaAmount: number;
  public incomeTaxReferenceNumber: string;
  public preferredMinArbRate: number;
  public maxTradeAmount: number = 499500;

  public pips: number;
  public isDefaultPipsOverridenForUser: boolean;

  public krakenReference: string;
  public circleReference: string;

  public user: Users;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
